<template>
  <h6 class="element-header">
    Einzelcoaching - {{ coaching?.nameOfCoaching?.operationTypeTranslated }}
  </h6>

  <div>
    <h5 class="form-header">Berichtsportale:</h5>
    <div class="row mb-3">
      <div class="col-12">
        <h6 class="form-header">Fortschritt</h6>
        <div class="progress">
          <div class="progress-bar" role="progressbar" aria-valuemax="100" aria-valuemin="0" aria-valuenow="25"
               :style="{ width: styleWidth }">
            {{ formattedUnitsDonePercent }}%
          </div>
        </div>
      </div>
    </div>

    <div class="row m-0 portal_user_data p-3">

      <div class="col-xl-4 col-lg-5 col-md-12 mb-4">
        <div class="row">
          <div class="col-sm-5 col-6 mb-1"><strong>Vorname:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">{{ coaching?.unemployed?.firstName }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Nachname:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">{{ coaching?.unemployed?.lastName }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>JC / AA Nummer:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">{{ coaching?.unemployed?.aaNumber || 'Keine Angaben' }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Versicherungsnr:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">{{
              coaching?.unemployed?.insuranceNumber || 'Keine Angaben'
            }}
          </div>

          <div class="col-sm-5 col-6 mb-1"><strong>Email:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic text-break">{{
              coaching?.unemployed?.email || 'Keine Angaben'
            }}
          </div>

          <div class="col-sm-5 col-6 mb-1"><strong>Telefonnummer:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">{{ coaching?.unemployed?.phone || 'Keine Angaben' }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Sachbearbeiter:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">{{ coaching?.clerk || 'Keine Angaben' }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Adresse:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">
            {{ coaching?.unemployed?.address }},
            {{ coaching?.unemployed?.zip }} {{ coaching?.unemployed?.city }}
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-lg-3 col-md-12 mb-4">
        <div class="d-inline-block text-start">
          <h6 class="fw-bold mb-2">Gewählte Maßnahmen:</h6>
          <p class="mb-3 ms-1">{{ coaching?.nameOfCoaching?.operationTypeTranslated }}</p>

          <h6 class="fw-bold mb-2">Gewählte Module:</h6>
          <div v-if="
                 coaching?.nameOfCoaching?.operationType === 'modular_integration_coaching' ||
                 coaching?.nameOfCoaching?.operationType === 'go_work_mobile'">
            <div v-for="(details, index) in coaching.moduleDetails" :key="index" class="mb-1">
              <span class="badge text-bg-light text-start w-100" :style="getStatusStyle(details.unitsDonePercent)">
                {{ details.name }} - Einheiten: {{ details.unitsDone }}
              </span>
            </div>
          </div>
          <div v-else class="ms-1">Keine Angaben</div>
        </div>
      </div>

      <div class="col-xl-4 col-lg-4 col-md-12 mb-4">
        <div class="d-flex flex-wrap justify-content-lg-end justify-content-center">

          <div class="portal-export-item text-center" style="width: 110px;"
               v-if="coaching?.nameOfCoaching?.operationType === 'modular_integration_coaching'">
            <a href="javascript:void(0)" class="btn portal_pdf_export portal-export-button w-100 d-flex flex-column align-items-center p-2"
               @click="downloadFile(`/portal/private-coaching/cv-pdf/${coaching.id}`, undefined)">
              <img
                  src="../../../../assets/img/pdf_icon_version4.png"
                  alt="PDF"
                  style="width: 55px; height: auto; object-fit: contain;"
                  class="mb-2"/>
              <p class="small mb-0 text-dark fw-bold" style="line-height: 1.1;">Lebenslauf</p>
            </a>
          </div>

          <div class="portal-export-item text-center" style="width: 110px;">
            <a href="javascript:void(0)" class="btn portal_pdf_export portal-export-button w-100 d-flex flex-column align-items-center p-2"
               @click="downloadFile(`/portal/private-coaching/final-report-pdf/${coaching.id}`, undefined)">
              <img
                  src="../../../../assets/img/pdf_icon_version4.png"
                  alt="PDF"
                  style="width: 55px; height: auto; object-fit: contain;"
                  class="mb-2"/>
              <p class="small mb-0 text-dark fw-bold" style="line-height: 1.1;">Abschlussbericht</p>
            </a>
          </div>

          <div class="portal-export-item text-center" style="width: 110px;" v-if="coaching.digitalSignature">
            <a href="javascript:void(0)" class="btn portal_pdf_export portal-export-button w-100 d-flex flex-column align-items-center p-2"
               @click="downloadFile(`/portal/private-coaching/meeting-list-pdf/${coaching.id}`, undefined, filtersFormated)">
              <img
                  src="../../../../assets/img/pdf_icon_version4.png"
                  alt="PDF"
                  style="width: 55px; height: auto; object-fit: contain;"
                  class="mb-2"/>
              <p class="small mb-0 text-dark fw-bold" style="line-height: 1.1;">Anwesenheitsliste</p>
            </a>
          </div>
        </div>
      </div>

      <div class="col-12 mt-2 border-top pt-3">
        <div class="d-flex flex-column flex-md-row align-items-center w-100">

          <div class="d-flex flex-column flex-sm-row align-items-center g-2 text-center text-md-start mb-3 mb-md-0">

            <div v-if="coaching?.nameOfCoaching?.operationType === 'modular_integration_coaching'"
                 class="me-sm-2 mb-2 mb-sm-0">
              <button v-if="coaching.digitalSignature" class="btn btn-outline-primary btn-md w-100"
                      @click.prevent="handleUnemployedDigitalSignatureModal()">
                <i class="os-icon os-icon-edit-3 me-1"></i> Lebenslauf & Dokumente digitale Unterschrift
              </button>
            </div>

            <div class="mb-2 mb-sm-0" v-if="coaching.digitalSignature">
              <button class="btn btn-outline-primary btn-md w-100"
                      @click.prevent="handleRemoteDigitalSignatureLinkModal()">
                <i class="os-icon os-icon-globe me-1"></i> Digitale Unterschrift ONLINE
              </button>
            </div>
          </div>

          <div class="text-center text-md-end ms-md-auto">
            <div class="h5 mb-0">
              <strong>{{ coaching?.calculatedUnits?.unitsDone }}</strong> / {{ coaching?.calculatedUnits?.maxUnits }}
              Einheiten
            </div>
            <div v-if="coaching?.calculatedUnits?.unitsLeft < 3"
                 class="text-danger fw-bold mt-1">
              Achtung: {{ coaching.calculatedUnits.unitsLeft.toFixed(2) }} Einheiten offen
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>

  <Modal
      v-model="showUnemployedDigitalSignatureModal"
      title="Kunde digitale Unterschrift"
      :hide-cancel="true"
      :button-label="$t('general.button.save')"
      sizeModal="modal-md"
      :hide-footer="true"
      classFooter="justify-content-center">
    <UnemployedDigitalSignatureForm
        :unemployedId="coaching.unemployed.id"
        @updateDigitalSignature="response"
        v-model:submitForm="formSubmit"/>
  </Modal>

  <Modal
      v-model="showRemoteDigitalSignatureLinkModal"
      title="Digitale Unterschrift ONLINE"
      :hide-cancel="true"
      :button-label="$t('general.button.save')"
      sizeModal="modal-md"
      :hide-footer="true"
      classFooter="justify-content-center">
    <RemoteLInkForm
        :coachingId="coaching.id"
        :email="coaching?.unemployed?.email"
        :startDate="coaching?.startDate"
        :endDate="coaching?.endDate"
        @updateDigitalSignature="response"
        v-model:submitForm="formSubmit"/>
  </Modal>
</template>

<script setup>
import Modal from '@/components/modal/Modal.vue';
import {CloseToast} from '@/components/VueToast';
import {downloadFile} from '@/shared/functions';
import UnemployedDigitalSignatureForm from '@/views/App/Portal/PrivateCoaching/UnemployedDigitalSignatureForm.vue';
import {computed, defineEmits, defineProps, onMounted, ref, toRefs, watch} from 'vue';
import RemoteLInkForm from "@/views/App/Portal/PrivateCoaching/RemoteDigitalSignature/RemoteLInkForm.vue";

const emit = defineEmits(['update:digitalDigitalSignature']);
const showUnemployedDigitalSignatureModal = ref(false);
const showRemoteDigitalSignatureLinkModal = ref(false);
const formSubmit = ref(false);
const missingUnemployedDigitalSignature = ref(false);

watch(formSubmit, (newValue) => {
  showUnemployedDigitalSignatureModal.value = false;
  showRemoteDigitalSignatureLinkModal.value = false
});

const props = defineProps({
  coaching: {
    type: Object,
    required: true,
  },
  showUnemployedDigitalSignatureModal: {
    type: Boolean,
    default: false,
    required: false,
  },
  showRemoteDigitalSignatureLinkModal: {
    type: Boolean,
    default: false,
    required: false,
  },
  filtersFormated: {
    type: Object,
    required: false,
  },
});

const coaching = toRefs(props)['coaching'];

watch(coaching?.value.unemployed?.digitalSignatureImage, (newValue) => {
  missingUnemployedDigitalSignature.value = !!newValue;
});

function response(percent) {
  missingUnemployedDigitalSignature.value = percent;
}

function getStatusStyle(percent) {
  if (percent === 0) return {color: 'red', fontSize: '13px'};
  if (percent === 100) return {color: 'green', fontSize: '13px'};
  return {color: 'orange', fontSize: '13px'};
}

const unitsDonePercent = ref(0.0);
const styleWidth = computed(() => {
  if (unitsDonePercent.value === 0.0) {
    return '0%'; // Explicitly return "0%"
  } else if (unitsDonePercent.value < 1) {
    return '3%'; // Explicitly return "3%"
  } else {
    return unitsDonePercent.value + '%'; // Correct concatenation
  }
});

// Format the percentage value (2 decimal places)
const formattedUnitsDonePercent = computed(() => {
  return unitsDonePercent.value.toFixed(2).replace('.', ',');
});

function handleUnemployedDigitalSignatureModal() {
  CloseToast();
  closeModals();
  showUnemployedDigitalSignatureModal.value = true;
}

function handleRemoteDigitalSignatureLinkModal() {
  CloseToast();
  closeModals();
  showRemoteDigitalSignatureLinkModal.value = true;
}

function closeModals(){
  showRemoteDigitalSignatureLinkModal.value = false
  showUnemployedDigitalSignatureModal.value = false;
}


watch(() => coaching.value.unitsDonePercent, (newVal) => {
  if (newVal !== null) {
    unitsDonePercent.value = +newVal;
  }
});

onMounted(() => { // Use onMounted to ensure props are available
  if (coaching.value && coaching.value.unitsDonePercent !== null) {
    unitsDonePercent.value = +coaching.value.unitsDonePercent;
  }
});
</script>

<style scoped>

</style>